module.exports = __webpack_public_path__ + "img/matsu_bg.a5b6b1c0.jpg";